/* HPL — delivery dates for the product page "Get it by" line, the
   Delivery & returns drawer, the row under the trust badges and the basket note.

   SOURCE OF TRUTH: the Essential Estimated Delivery app settings (widgets.json).
   Each app widget targets a collection, and we read from it:
     cut-off time, dispatch (processing) days, processing days to add,
     transit days, delivery days, and blocked/holiday dates.
     "Delivery Next Day"   -> in stock  -> shown as NEXT DAY (free upgrade)
     "Delivery Second Day" -> backorder -> shown as TWO DAY
   Change a setting in the app and every surface follows. If the app's file
   can't be loaded, the RULES below are used as a fallback.

   The collections are kept up to date by the Cloud Run job that reads
   Linnworks Default stock. A basket with any Two Day item ships as one parcel
   on Two Day. All times are UK time (Europe/London).

   Loaded as a normal asset so it still runs after the cart drawer is
   re-rendered. Safe to include twice.
*/
(function () {
  if (window.HPLDelivery) { return; }

  /* App weekday letters. In the app "S" is Sunday (verified against the widget). */
  var DAY = { Su: 0, S: 0, M: 1, T: 2, W: 3, Th: 4, F: 5, Sa: 6 };

  /* Fallback only — used when the app's settings can't be loaded. */
  var RULES = {
    next:   { service: 'Next Day', cut: [15, 30], proc: 0, procDays: [0, 1, 2, 3, 4, 5], transit: 1, transitDays: [1, 2, 3, 4, 5], blocked: [], tBlocked: [] },
    second: { service: 'Two Day',  cut: [14, 30], proc: 1, procDays: [0, 1, 2, 3, 4, 5], transit: 1, transitDays: [1, 2, 3, 4, 5], blocked: [], tBlocked: [] }
  };

  var CACHE_KEY = 'hplDeliveryCfg:v2';
  var CACHE_MS = 30 * 60 * 1000;

  /* ---------- dates ---------- */

  function ukNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
  }
  function ukDateOf(iso) {
    var d = new Date(new Date(iso).toLocaleString('en-US', { timeZone: 'Europe/London' }));
    d.setHours(0, 0, 0, 0);
    return d;
  }
  function midnight(d) { var x = new Date(d); x.setHours(0, 0, 0, 0); return x; }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function md(d) { return (d.getMonth() + 1) * 100 + d.getDate(); }

  function isBlocked(d, list) {
    for (var i = 0; i < list.length; i++) {
      var r = list[i];
      if (!r || !r.start) { continue; }
      var s = ukDateOf(r.start), e = ukDateOf(r.end || r.start);
      if (r.repeatOption === 'every_year') {
        var a = md(s), b = md(e), x = md(d);
        if (a <= b ? (x >= a && x <= b) : (x >= a || x <= b)) { return true; }
      } else if (d >= s && d <= e) {
        return true;
      }
    }
    return false;
  }

  function okDay(d, days, blocked) {
    return days.indexOf(d.getDay()) !== -1 && !isBlocked(d, blocked || []);
  }

  function pastCut(now, cut) {
    return now.getHours() > cut[0] || (now.getHours() === cut[0] && now.getMinutes() >= cut[1]);
  }

  /* First day the order can be picked: today if it's a dispatch day and before the cut-off. */
  function firstPick(now, cut, days, blocked) {
    var d = midnight(now);
    if (!okDay(d, days, blocked) || pastCut(now, cut)) {
      do { d = addDays(d, 1); } while (!okDay(d, days, blocked));
    }
    return d;
  }

  function dispatchDate(now, cfg, cut, days) {
    var d = firstPick(now, cut, days, cfg.blocked);
    for (var i = 0; i < cfg.proc; i++) {
      do { d = addDays(d, 1); } while (!okDay(d, days, cfg.blocked));
    }
    return d;
  }

  function arrival(from, n, cfg) {
    var d = new Date(from), added = 0;
    while (added < n) {
      d = addDays(d, 1);
      /* No deliveries on transit-blocked days or on shop holidays (e.g. Christmas Day). */
      if (okDay(d, cfg.transitDays, cfg.tBlocked) && !isBlocked(d, cfg.blocked || [])) { added++; }
    }
    return d;
  }

  function nextCutoff(now, cfg) {
    var d = firstPick(now, cfg.cut, cfg.procDays, cfg.blocked);
    d.setHours(cfg.cut[0], cfg.cut[1], 0, 0);
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function fmtCut(cut) {
    var h = cut[0] % 12 || 12, m = cut[1];
    return h + (m ? '.' + (m < 10 ? '0' : '') + m : '') + (cut[0] < 12 ? 'am' : 'pm');
  }
  /* "Monday, 12th October" */
  function ordinal(n) {
    var t = n % 100;
    if (t >= 11 && t <= 13) { return n + 'th'; }
    return n + ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
  }
  function fmtLong(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'long' }) + ', ' + ordinal(d.getDate()) + ' ' +
      d.toLocaleDateString('en-GB', { month: 'long' });
  }
  /* "18 hrs 17 mins 57 secs" (or "1 day 3 hrs 5 mins" when over a day) */
  function unit(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function fmtLeft(ms) {
    var secs = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(secs / 86400), h = Math.floor((secs % 86400) / 3600),
        m = Math.floor((secs % 3600) / 60), s = secs % 60;
    if (d) { return unit(d, 'day', 'days') + ' ' + unit(h, 'hr', 'hrs') + ' ' + unit(m, 'min', 'mins'); }
    return unit(h, 'hr', 'hrs') + ' ' + unit(m, 'min', 'mins') + ' ' + unit(s, 'sec', 'secs');
  }

  function estimate(type) {
    var cfg = config[type] || config.next;
    var now = ukNow(), today = midnight(now);
    var disp = dispatchDate(now, cfg, cfg.cut, cfg.procDays);
    var gap = Math.round((disp - today) / 86400000);
    var arrive = arrival(disp, cfg.transit, cfg);
    var head = gap === 0 ? 'Dispatched today'
      : gap === 1 ? 'Dispatched tomorrow'
      : 'Dispatched ' + disp.toLocaleDateString('en-GB', { weekday: 'long' });
    return {
      head: head,
      ordered: fmt(today),
      dispatched: fmt(disp),
      service: cfg.service,
      /* Next Day is a selling point, so it's named; the standard service is just "Delivery". */
      serviceLabel: cfg.service === 'Next Day' ? 'Next Day delivery' : 'Delivery',
      arrives: fmt(arrive),
      arrivesLong: fmtLong(arrive),
      cutoff: fmtCut(cfg.cut),
      countdown: fmtLeft(nextCutoff(now, cfg) - now)
    };
  }

  /* ---------- widget settings ---------- */

  var config = { next: RULES.next, second: RULES.second };

  function fromApp(base, c) {
    if (!c) { return base; }
    var out = {};
    for (var k in base) { if (Object.prototype.hasOwnProperty.call(base, k)) { out[k] = base[k]; } }
    var t = c.processingCutoffTime || {};
    var h = parseInt(t.hours, 10), m = parseInt(t.minutes, 10) || 0;
    if (!isNaN(h)) {
      if (t.amPM === 'PM' && h < 12) { h += 12; }
      if (t.amPM === 'AM' && h === 12) { h = 0; }
      out.cut = [h, m];
    }
    function days(list, fallback) {
      if (!list || !list.length) { return fallback; }
      var res = [];
      for (var i = 0; i < list.length; i++) { if (DAY[list[i]] !== undefined && res.indexOf(DAY[list[i]]) === -1) { res.push(DAY[list[i]]); } }
      return res.length ? res : fallback;
    }
    out.procDays = days(c.processingWorkingDays, base.procDays);
    out.transitDays = days(c.transitWorkingDays, base.transitDays);
    if (typeof c.shortestProcessingTime === 'number' && c.shortestProcessingTime >= 0) { out.proc = c.shortestProcessingTime; }
    if (typeof c.shortestTransitTime === 'number' && c.shortestTransitTime > 0) { out.transit = c.shortestTransitTime; }
    out.blocked = c.blockedDates || [];
    out.tBlocked = c.transitBlockedDates || [];
    return out;
  }

  function apply(json) {
    var list = (json && json.deliveries) || [];
    for (var i = 0; i < list.length; i++) {
      var w = list[i];
      if (!w || !w.isPublished || w.placementType !== 'product_page' || !w.placement) { continue; }
      var cols = w.placement.specificCollections || [];
      for (var j = 0; j < cols.length; j++) {
        if (cols[j].shopifyHandle === 'delivery-next-day') { config.next = fromApp(RULES.next, w.conditions); }
        if (cols[j].shopifyHandle === 'delivery-second-day') { config.second = fromApp(RULES.second, w.conditions); }
      }
    }
  }

  function loadConfig(done) {
    try {
      var hit = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (hit && Date.now() - hit.t < CACHE_MS) { apply(hit.d); done(); return; }
    } catch (e) {}
    var shop = window.Shopify && window.Shopify.shop;
    if (!shop || !window.fetch) { done(); return; }
    fetch('https://estimated-delivery-s3-prod.devbroth.com/' + shop + '/widgets.json?t=' + Math.floor(Date.now() / CACHE_MS))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j) {
          apply(j);
          try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: { deliveries: j.deliveries } })); } catch (e) {}
        }
        done();
      })
      .catch(function () { done(); });
  }

  /* ---------- rendering ---------- */

  function setAll(root, key, text) {
    var els = root.querySelectorAll('[data-hpl-d="' + key + '"]');
    for (var i = 0; i < els.length; i++) { if (els[i].textContent !== text) { els[i].textContent = text; } }
  }

  function renderProduct() {
    var dd = document.querySelector('[data-hpl-delivery-product]');
    if (!dd) { return; }
    var e;
    try { e = estimate(dd.getAttribute('data-type')); } catch (err) { return; }
    var keys = ['head', 'ordered', 'dispatched', 'arrives', 'arrivesLong', 'serviceLabel', 'cutoff', 'countdown'];
    for (var i = 0; i < keys.length; i++) { setAll(document, keys[i], e[keys[i]]); }
    setAll(document, 'row', e.service === 'Next Day'
      ? 'Next Day delivery · Get it ' + e.arrives
      : 'Get it ' + e.arrives + ' · Free over £25');
  }

  function renderCart() {
    var notes = document.querySelectorAll('[data-hpl-delivery]');
    /* A freshly rendered note has no checked fee yet: confirm it against the live basket. */
    if (document.querySelector('[data-hpl-delivery-fee]:not([data-total])')) { refreshFee(); }
    for (var i = 0; i < notes.length; i++) {
      var type = notes[i].getAttribute('data-type') ||
        (notes[i].getAttribute('data-backorder') === 'true' ? 'second' : 'next');
      var e;
      try { e = estimate(type); } catch (err) { return; }
      var dates = notes[i].querySelectorAll('[data-hpl-delivery-date]');
      for (var j = 0; j < dates.length; j++) { if (dates[j].textContent !== e.arrivesLong) { dates[j].textContent = e.arrivesLong; } }
      var left = notes[i].querySelectorAll('[data-hpl-delivery-countdown]');
      for (var k = 0; k < left.length; k++) { if (left[k].textContent !== e.countdown) { left[k].textContent = e.countdown; } }
    }
  }

  function render() { renderProduct(); renderCart(); }

  /* "Next Day delivery · £2.99" vs "· FREE" in the basket. The note's Liquid
     can be stale after the drawer re-renders, so this reads the live basket
     total from /cart.js and sets the fee itself. */
  var FREE_MIN = 2500, feeBusy = false, feeAgain = false;
  function setFee(total) {
    var fees = document.querySelectorAll('[data-hpl-delivery-fee]');
    for (var i = 0; i < fees.length; i++) {
      var html = total >= FREE_MIN
        ? '<strong class="hpl-cart-delivery__free">FREE</strong>'
        : '£2.99 <span class="hpl-cart-delivery__hint">(free over £25)</span>';
      if (fees[i].getAttribute('data-total') !== String(total)) {
        fees[i].innerHTML = html;
        fees[i].setAttribute('data-total', String(total));
      }
    }
  }
  function refreshFee() {
    if (!window.fetch) { return; }
    if (feeBusy) { feeAgain = true; return; }
    feeBusy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        setFee(c.total_price || 0);
        var empty = !c.item_count;
        var ns = document.querySelectorAll('[data-hpl-delivery]');
        for (var k = 0; k < ns.length; k++) { ns[k].style.display = empty ? 'none' : ''; }
      })
      .catch(function () {})
      .then(function () {
        feeBusy = false;
        if (feeAgain) { feeAgain = false; refreshFee(); }
      });
  }

  /* Countdowns, every second: product page / drawer, and the basket note. */
  function tick() {
    var now = ukNow();
    var dd = document.querySelector('[data-hpl-delivery-product]');
    if (dd) {
      var cfg = config[dd.getAttribute('data-type')] || config.next;
      setAll(document, 'countdown', fmtLeft(nextCutoff(now, cfg) - now));
    }
    var notes = document.querySelectorAll('[data-hpl-delivery]');
    for (var i = 0; i < notes.length; i++) {
      var c = config[notes[i].getAttribute('data-type')] || config.next;
      var left = notes[i].querySelectorAll('[data-hpl-delivery-countdown]');
      var txt = fmtLeft(nextCutoff(now, c) - now);
      for (var k = 0; k < left.length; k++) { if (left[k].textContent !== txt) { left[k].textContent = txt; } }
    }
    if (now.getSeconds() === 0) { render(); }
  }

  /* Move the "Get it by" line to where the app widget sits (under the reviews
     badge), and hide the app widget so there is only one. */
  function placeGetBy() {
    var line = document.querySelector('[data-hpl-getby]');
    if (!line || line.getAttribute('data-placed')) { return; }
    var app = document.querySelector('essential-estimated-delivery-app-block');
    var appBlock = app && app.closest('.shopify-app-block, [id^="shopify-block-"]');
    var anchor = appBlock ||
      document.querySelector('.product-info .product-info__rating') ||
      document.querySelector('.product-info .product-info__title, .product-info h1');
    if (!anchor || !anchor.parentNode) { return; }
    if (appBlock) {
      appBlock.parentNode.insertBefore(line, appBlock);
      appBlock.style.display = 'none';
    } else {
      anchor.parentNode.insertBefore(line, anchor.nextSibling);
    }
    line.hidden = false;
    line.setAttribute('data-placed', '1');
  }

  /* ---------- drawer ---------- */

  function money(p) { return '£' + (p / 100).toFixed(2); }

  function itemPrice(dd) {
    var el = document.querySelector('.product-info .product-info__price .price__current');
    var n = el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : NaN;
    return isNaN(n) ? parseInt(dd.getAttribute('data-price'), 10) || 0 : Math.round(n * 100);
  }

  function updateBasket(dd) {
    var price = itemPrice(dd);
    var qtyEl = document.querySelector('.product-info product-form [name="quantity"], .product-info [name="quantity"]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    setAll(dd, 'price', money(price * qty));
    var min = parseInt(dd.getAttribute('data-threshold'), 10) || 2500;
    var show = function (total) {
      var after = total + price * qty;
      var nudge = dd.querySelector('[data-hpl-nudge]'), ok = dd.querySelector('[data-hpl-ok]');
      if (after >= min) { nudge.hidden = true; ok.hidden = false; return; }
      ok.hidden = true; nudge.hidden = false;
      setAll(dd, 'away', money(min - after));
      var bar = dd.querySelector('[data-hpl-d="bar"]');
      if (bar) { bar.style.width = Math.min(100, Math.round(after / min * 100)) + '%'; }
    };
    show(0);
    if (window.fetch) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { show(c.total_price || 0); })
        .catch(function () {});
    }
  }

  var lastFocus = null;

  function openDrawer() {
    var dd = document.getElementById('hpl-delivery-drawer');
    if (!dd) { return; }
    lastFocus = document.activeElement;
    render();
    updateBasket(dd);
    dd.hidden = false;
    document.documentElement.classList.add('hpl-dd-lock');
    void dd.offsetWidth; /* commit the start position so the slide-in animates */
    setTimeout(function () {
      dd.classList.add('is-open');
      var p = dd.querySelector('.hpl-dd__panel');
      if (p) { p.focus({ preventScroll: true }); }
    }, 20);
  }

  function closeDrawer() {
    var dd = document.getElementById('hpl-delivery-drawer');
    if (!dd || dd.hidden) { return; }
    dd.classList.remove('is-open');
    document.documentElement.classList.remove('hpl-dd-lock');
    setTimeout(function () { dd.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  function addToBasket() {
    var btn = document.querySelector('.product-info product-form [name="add"], .product-info form[action*="/cart/add"] [type="submit"]');
    closeDrawer();
    if (btn && !btn.disabled) { setTimeout(function () { btn.click(); }, 320); }
  }

  function onClick(ev) {
    var t = ev.target;
    if (!t || !t.closest) { return; }
    if (t.closest('[data-hpl-dd-open]')) { ev.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-hpl-dd-add]')) { ev.preventDefault(); addToBasket(); return; }
    if (t.closest('[data-hpl-dd-close]')) { ev.preventDefault(); closeDrawer(); }
  }

  function onKey(ev) {
    if (ev.key === 'Escape') { closeDrawer(); return; }
    if ((ev.key === 'Enter' || ev.key === ' ') && ev.target && ev.target.matches &&
        ev.target.matches('[data-hpl-dd-open]:not(button)')) {
      ev.preventDefault(); openDrawer();
    }
  }

  /* ---------- start ---------- */

  function start() {
    placeGetBy();
    render();
    loadConfig(render);
    setInterval(tick, 1000);
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
    document.addEventListener('cart:updated', function () { setTimeout(render, 0); refreshFee(); });
    setInterval(render, 30000);
    if (window.MutationObserver) {
      var queued = false, feeTimer = null;
      new MutationObserver(function (muts) {
        /* Ignore our own updates (countdown text etc.); react to anything else
           changing inside the basket, e.g. a quantity change or removed item. */
        var basketChanged = false;
        for (var i = 0; i < muts.length && !basketChanged; i++) {
          var el = muts[i].target.nodeType === 1 ? muts[i].target : muts[i].target.parentElement;
          if (!el || !el.closest) { continue; }
          if (el.closest('[data-hpl-delivery], [data-hpl-getby], #hpl-delivery-drawer')) { continue; }
          if (el.closest('cart-drawer, cart-items, #cart, .cc-main-cart, #cart-drawer')) { basketChanged = true; }
        }
        if (basketChanged) {
          clearTimeout(feeTimer);
          feeTimer = setTimeout(refreshFee, 300);
        }
        if (queued) { return; }
        queued = true;
        setTimeout(function () { queued = false; renderCart(); }, 50);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  window.HPLDelivery = { estimate: estimate, render: render, open: openDrawer, close: closeDrawer, config: config };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
